// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"25":"3512d9b602663eee44a0","155":"c0f75a2d695ca92ca59b"}[chunkId] + ".js";
};